import { render } from "./HeaderMobileAI.vue?vue&type=template&id=3d85b96a"
import script from "./HeaderMobileAI.vue?vue&type=script&lang=js"
export * from "./HeaderMobileAI.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__